export default __webpack_public_path__ + "static/media/466.59769600.gif";